import './sapCourses.css';
import SapDomainData2 from './sapdomaindata2';
import { useState } from 'react';
import { Pagination } from '@mui/material';
import usePagination from './pagination';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import QuickLinks from './QuickLinks';
import SapNavBar from './sapNavBar';
import OracleQuickLinks from '../oracle/OracleQuickLinks';
import { saraswathi_mail, atci_lkm_sap_mail } from '../utils/mailIds';

const SapCourses = props => {
  var arr = [];

  let cCode = '';
  if (Object.keys(props.match.params).length > 0)
    cCode = props.match.params.code;

  const [coursedata, setCourseData] = useState(SapDomainData2);
  const [searching, setSearching] = useState('');
  const [filteredResults, setFilteredResults] = useState([]);
  const [dropDownFilter, setDropDownFilter] = useState([]);
  const [dropDownFilter1, setDropDownFilter1] = useState([]);
  const [page, setPage] = useState(1);
  const PER_PAGE = 6;
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState('');
  const [selected1, setSelected1] = useState('');
  const [modalContent, setModalContent] = useState({});
  const [show, setShow] = useState(false);

  const count = Math.ceil(coursedata.length / PER_PAGE);
  const _DATA = usePagination(coursedata, PER_PAGE);
  const count1 = Math.ceil(filteredResults.length / PER_PAGE);
  const _DATA1 = usePagination(filteredResults, PER_PAGE);
  const count2 = Math.ceil(dropDownFilter.length / PER_PAGE);
  const _DATA2 = usePagination(dropDownFilter, PER_PAGE);
  const count3 = Math.ceil(dropDownFilter1.length / PER_PAGE);
  const _DATA3 = usePagination(dropDownFilter1, PER_PAGE);

  const courseCount = Math.ceil(filteredResults.length);
  const courseCount1 = Math.ceil(dropDownFilter.length);
  const courseCount2 = Math.ceil(dropDownFilter1.length);

  if (cCode !== '') {
    arr = coursedata.find(course => {
      return course.sno === cCode;
    });
  }

  const handleOpen = sno => {
    setOpen(true);
    const clickedCourseDetail = SapDomainData2.filter((obj) => {
      return obj.sno === sno;
    })
    setModalContent(clickedCourseDetail[0]);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleOpenModal = () => {
    setShow(true);
  };
  const handleCloseModal = () => {
    setShow(false);
  };
  const botClickFun = () => {
    document.getElementById('cai-webclient-builtin-button').click();
  };

  let dropdownFiltering = [];
  let dropdownFiltering1 = [];
  const eventChange = e => {
    return setSearching(e.target.value);
  };
  const handleChange = (e, p) => {
    setPage(p);
    _DATA.jump(p) ? _DATA.jump(p) : _DATA1.jump(p);
  };
  const handleChange1 = (e, p) => {
    setPage(p);
    _DATA2.jump(p);
  };
  const handleChange2 = (e, p) => {
    setPage(p);
    _DATA3.jump(p);
  };
  const images = ['img_container2', 'img_container', 'img_container1'];
  let image;
  let imgRepitation = 0;

  const handleEnterSearch = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      searchData();
    }
  }

  const searchData = () => {
    if (searching !== '' && dropDownFilter1.length > 0 && dropDownFilter.length > 0) {
      const filteredData = dropDownFilter1.filter(item => {
        return Object.values(item).join('').toLowerCase().includes(searching.toLowerCase());
      });
      setFilteredResults(filteredData);
    } else if (searching !== '' && dropDownFilter.length > 0) {
      const filteredData = dropDownFilter.filter(item => {
        return Object.values(item).join('').toLowerCase().includes(searching.toLowerCase());
      });
      setFilteredResults(filteredData);
    } else if (searching !== '' && dropDownFilter1.length > 0) {
      const filteredData = dropDownFilter1.filter(item => {
        return Object.values(item).join('').toLowerCase().includes(searching.toLowerCase());
      });
      setFilteredResults(filteredData);
    } else if (searching !== '') {
      const filteredData = coursedata.filter(item => {
        return Object.values(item).join('').toLowerCase().includes(searching.toLowerCase());
      });
      setFilteredResults(filteredData);
    }
  };

  const changeDomain = event => {
    setSelected(event.target.value);
    coursedata.forEach(elem => {
      if (elem.domain === event.target.value) {
        dropdownFiltering.push({
          ...elem
        });
      }
    });
    setDropDownFilter(dropdownFiltering);
  };
  const changeSpecialization = event => {
    setSelected1(event.target.value);
    coursedata.forEach(elem => {
      if (elem.specialization === event.target.value) {
        dropdownFiltering1.push({
          ...elem
        });
      }
    });
    setDropDownFilter1(dropdownFiltering1);
  };

  let domainList = [];
  Array.from(new Set(coursedata.map(obj => obj.domain))).map(Domain => {
    return domainList.push({ key: Domain, label: Domain });
  });

  const resetSearch = () => {
    setDropDownFilter([]);
    setDropDownFilter1([]);
    setFilteredResults([]);
    setSearching('');
    setSelected('');
    setSelected1('');
  };
  const allData = data => {
    image = images[imgRepitation];
    imgRepitation = imgRepitation + 1;
    if (imgRepitation > 20) {
      imgRepitation = 1;
    }

    let bgImage = require('../images/courses/' + data['course_image'] + '.png');

    return (
      <>
        <div className="main_card_container" key={data['course_name']}>
          <div className="sub_cart_container">
            <div className="img_container" style={{ backgroundImage: `url(${bgImage})` }}>
              <span>{data['course_name']}</span>
            </div>
            <div className="card_content">
              <div className="cardText">
                <div className="sourseInfo">
                <span className="prerequisite_label">This course covers: </span>
                  <p
                    className="courseInfoText"
                    dangerouslySetInnerHTML={{
                      __html: data['bulleted_description']
                    }}
                  ></p>
                </div>

                <Modal
                  hideBackdrop
                  open={open}
                  onClose={handleClose}
                  aria-labelledby="child-modal-title"
                  closeAfterTransition
                  aria-describedby="child-modal-description"
                >
                  <Box className="model">
                    <div className="model_heading">
                      <h3 className="paramodel">{modalContent.course_name}</h3>
                      <span className="close_btn_model" onClick={handleClose}>
                        Close
                      </span>
                    </div>
                    <hr />
                    <div className="mainRootWrapper">
                      <div>
                        <h4>Domain</h4>
                        <p>{modalContent.domain}</p>
                      </div>
                      <div>
                        <h4>Specialization</h4>
                        <p>{modalContent.specialization}</p>
                      </div>
                      <div>
                        <h4>Prerequisite</h4>
                        <p>{modalContent['pre-requisite']}</p>
                      </div>
                     <div>
                      
                      <p>
                        <span className='card_icon_wrapper1'>
                          <img src={process.env.PUBLIC_URL + '/images/SAP/duration_icon.png'} alt="SVG as an img" />
                          <span>{modalContent['duration']}h</span>
                        </span>
                        
                        <span className='card_icon_wrapper'>
                        <img src={process.env.PUBLIC_URL + '/images/SAP/mode_icon.png'} alt="SVG as an img" />
                        <span className="mode-text">{modalContent['mode']}</span>
                        </span>
                      </p>

                     </div>
                      
                    </div>
                    <div className="mainRootWrapper1">
                    
                      <div>
                        <h4>Skill Name</h4>
                        <p>{modalContent['ssi_skill name']}<br /> {modalContent['ssi_skill2 name']}<br /> {modalContent['ssi_skill3 name']}</p>
                      </div>
                      <div>
                        <h4>Course Level</h4>
                        <p>{modalContent['course_level']}</p>
                      </div>
                      <div></div>
                      <div>
                        <p className="model_link">
                          <a href={modalContent.mylearning_url} target="_blank" rel="noreferrer">
                            {' '}
                           Workday Link
                          </a>
                        </p>
                      </div>
                    </div>

                    <h4 className="model_descrip">Description</h4>
                    <p className="model_desrcip_data">{modalContent['description']}</p>

                    <div>
                      <h4>Learning Outcomes</h4>
                      <p>{modalContent['learning_outcomes']}</p>
                    </div>
                  </Box>
                </Modal>
                <div className="prerequisite-block">
                  <span className="prerequisite_label">Prerequisite: </span>
                  <span className="prerequisite_text"> {data['pre-requisite']} </span>
                </div>
                <div className="prerequisite-block">
                  <span className="prerequisite_label">Skill Name: </span>
                  <span className="prerequisite_text"> {data['ssi_skill name']} </span>
                </div>
                <div className="open_btn_model" onClick={() => handleOpen(data['sno'])}>
                  Show more
                </div>
              </div>
              <div className="card_icon">
                <div className="card_icon_wrapper">
                  <img src={process.env.PUBLIC_URL + '/images/SAP/mode_icon.png'} alt="SVG as an img" />
                  <span className="mode-text">{data['mode']}</span>
                </div>
                <div className="card_icon_wrapper1">
                  <img src={process.env.PUBLIC_URL + '/images/SAP/duration_icon.png'} alt="SVG as an img" />
                  <span className="duration-text">{data['duration']}h</span>
                </div>
              </div>
            </div>
          </div>
        </div >
      </>
    );
  };
  return (
    <>
      <SapNavBar />
      <div id="main_container" className="sap_main_container">
        {/* <div className="banner_container">
          <img src={process.env.PUBLIC_URL + '/images/SAP/Banner.png'} alt="Sap-Banner" />
        </div> */}
        <div className="testimonial_banner1">
          {/* <div>
              <h1>SAP Courses</h1>
              <span>Find all SAP courses</span>
              <p>Welcome to the SAP course database of E&IT Academy! Type a course or topic name and find the link to your course in an instant.</p>
          </div>           */}
          <img
            src={process.env.PUBLIC_URL + '/images/SAP/sap-new-banner-one.png'}
            alt="SAPcourses-Banner"
            className="img-responsive"
          />
        </div>

        <div className="section_container">
          <div className="banner-content">
            {/* <p>
              Welcome to the SAP course database of E&IT Academy! Type a course or topic name and find the link to your
              course in an instant.
            </p> */}
            <p>Welcome to a world of limitless possibilities! Our SAP learning offer you a gateway to explore the dynamic realm of enterprise software, enabling you to harness the full potential of SAP technologies. Get ready to dive deep into cutting-edge concepts, real-world case studies, and hands-on experiences that will elevate your expertise and propel you towards professional excellence.</p>
          </div>
          {/* <h2 className="searchHeading">Find all SAP courses</h2>
          <p className="infoPara">
              Welcome to the course database of E&IT Academy! Type a course or topic name and find the link to your course in an instant.
          </p>  */}
          <br />
          <br />
          {cCode !== '' ? (
            <h2 className="searchHeading">SAP Course</h2>
          ) : (
            <>
              <form className="form_container d-flex searchCourses">
                <div className="searchBox1">
                  <lable className="lable_container">Domain </lable>
                  <select className="selection_container" value={selected} onChange={e => changeDomain(e)}>
                    <option selected>All</option>
                    {domainList.map(item => {
                      return (
                        <option key={item.key} value={item.key}>
                          {item.label}
                        </option>
                      );
                    })}
                  </select>
                </div>
                <div className="searchBox2">
                  <lable className="lable_container1">Specialization </lable>
                  <select className="selection_container" value={selected1} onChange={changeSpecialization}>
                    <option className="option_container" selected>
                      All
                    </option>
                    {dropDownFilter.length > 0
                      ? Array.from(new Set(dropDownFilter.map(obj => obj.specialization))).map(itemname => {
                        return <option value={itemname}>{itemname}</option>;
                      })
                      : Array.from(new Set(coursedata.map(obj => obj.specialization))).map(Specialization => {
                        return (
                          <option className="option_container" value={Specialization}>
                            {Specialization}
                          </option>
                        );
                      })}
                  </select>
                </div>
                <div className="searchBox3">
                  <lable className="lable_container2">Keyword Search</lable>
                  <div className="goButton">
                    <input type="search" className="search_wrapper" onKeyPress={handleEnterSearch} onChange={eventChange} value={searching} />
                    <input className="search_btn" type="button" onClick={searchData} />
                    <input type="button" className="reset_btn" value="Reset" onClick={resetSearch} />
                  </div>
                </div>
              </form>
              <div className="course_count">
                {filteredResults.length > 0 && dropDownFilter.length > 0 && dropDownFilter1.length > 0
                  ? `${courseCount} Courses Found`
                  : dropDownFilter.length > 0 && dropDownFilter1.length > 0
                    ? `${courseCount2} Courses Found`
                    : filteredResults.length > 0 && dropDownFilter.length > 0
                      ? `${courseCount} Courses Found`
                      : filteredResults.length > 0 && dropDownFilter1.length > 0
                        ? `${courseCount} Courses Found`
                        : courseCount1 > 0
                          ? `${courseCount1} Courses Found`
                          : courseCount2 > 0
                            ? `${courseCount2} Courses Found`
                            : courseCount > 0
                              ? `${courseCount} Courses Found`
                              : ''}
              </div>{' '}
            </>
          )}
          <div className="top_container_bg">
            <div className="top_container">
              {cCode !== ''
                ? allData(arr)
                : filteredResults.length > 0 && dropDownFilter.length > 0 && dropDownFilter1.length > 0
                  ? _DATA1.currentData().map(data => {
                    return <>{allData(data)}</>;
                  })
                  : filteredResults.length > 0 && dropDownFilter.length > 0
                    ? _DATA1.currentData().map(data => {
                      return <>{allData(data)}</>;
                    })
                    : filteredResults.length > 0 && dropDownFilter1.length > 0
                      ? _DATA1.currentData().map(data => {
                        return <>{allData(data)}</>;
                      })
                      : dropDownFilter.length > 0 && dropDownFilter1.length > 0
                        ? _DATA3.currentData().map(data => {
                          return <>{allData(data)}</>;
                        })
                        : dropDownFilter1.length > 0
                          ? _DATA3.currentData().map(data => {
                            return <>{allData(data)}</>;
                          })
                          : dropDownFilter.length > 0
                            ? _DATA2.currentData().map(data => {
                              return <>{allData(data)}</>;
                            })
                            : filteredResults.length > 0
                              ? _DATA1.currentData().map(data => {
                                return <>{allData(data)}</>;
                              })
                              : _DATA.currentData().map(data => {
                                return <>{allData(data)}</>;
                              })}
            </div>
          </div>
          {cCode !== '' ? (
            ''
          ) : filteredResults.length > 0 && dropDownFilter.length > 0 && dropDownFilter1.length > 0 ? (
            <Pagination
              count={count1}
              size="large"
              page={page}
              onChange={handleChange}
              className="pagination_container"
            />
          ) : dropDownFilter.length > 0 && dropDownFilter1.length > 0 ? (
            <Pagination
              count={count3}
              size="large"
              page={page}
              onChange={handleChange2}
              className="pagination_container"
            />
          ) : filteredResults.length > 0 && dropDownFilter.length > 0 ? (
            <Pagination
              count={count1}
              size="large"
              page={page}
              onChange={handleChange}
              className="pagination_container"
            />
          ) : filteredResults.length > 0 && dropDownFilter1.length > 0 ? (
            <Pagination
              count={count1}
              size="large"
              page={page}
              onChange={handleChange}
              className="pagination_container"
            />
          ) : dropDownFilter1.length > 0 ? (
            <Pagination
              count={count3}
              size="large"
              page={page}
              onChange={handleChange2}
              className="pagination_container"
            />
          ) : dropDownFilter.length > 0 ? (
            <Pagination
              count={count2}
              size="large"
              page={page}
              onChange={handleChange1}
              className="pagination_container"
            />
          ) : filteredResults.length > 0 ? (
            <Pagination
              count={count1}
              size="large"
              page={page}
              onChange={handleChange}
              className="pagination_container"
            />
          ) : (
            <Pagination
              count={count}
              size="large"
              page={page}
              onChange={handleChange}
              className="pagination_container"
            />
          )}
        </div>
      </div>
      <div className="socialMediaWrap">
        <button className="iconBtn icon6">
          <a href="https://atci.lkm.eitacademy.accenture.com/SAPAcademy/sap-calendar/" target="_blank" rel="noreferrer">
            <img src={process.env.PUBLIC_URL + '/images/SAP/sap_calendar.png'} alt="oracle-icon" />
            <span>SAP Calendar</span>
          </a>
        </button>
        <button className="iconBtn icon5">
          <a href="https://atci.lkm.accenture.com/LKM-eCatalog/SAP-Flipbook" target="_blank" rel="noreferrer">
            <img src={process.env.PUBLIC_URL + '/images/SAP/catalogue_icon.png'} alt="ecatalogs-icon" />
            <span>SAP eCatalog</span>
          </a>
        </button>
        <button className="iconBtn icon4" onClick={botClickFun}>
          <img src={process.env.PUBLIC_URL + '/images/SocialLearning/noun-chatbot-4562760.svg'} alt="oracle-icon" />
          <span>SAP Bot</span>
        </button>
        <button onClick={handleOpenModal} className="iconBtn icon1">
          <img src={process.env.PUBLIC_URL + '/images/SocialLearning/present.svg'} alt="oracle-icon" />
          <span>Request for Training</span>
        </button>
        <Modal
          open={show}
          onClose={handleCloseModal}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
        >
          <div className="model-container">
            <span className="close_btn_model_reqtraining" onClick={handleCloseModal}>
              X
            </span>
            <h4>Request For Training</h4>
            <div className="model_heading_reqtraining">
              <p className="model_name_reqtraining">
                <a
                  href="https://lkmportal.atci.accenture.com/LMS/Need/RaiseTrainingRequest"
                  target="_blank"
                  rel="noreferrer"
                >
                  Link to raise training request
                </a>
              </p>
              <div className="modal_content_reqtraining">
                For further queries please get in touch with <br />
              </div>
              <p className="model_contact_reqtraining">
                <a href={`mailto:${saraswathi_mail}`} target="_blank" rel="noreferrer">
                  Swaminathan, Saraswathi.
                </a>
              </p>
            </div>
          </div>
        </Modal>
        <button className="iconBtn icon2">
          <a
            href="https://web.yammer.com/main/org/accenture.com/groups/eyJfdHlwZSI6Ikdyb3VwIiwiaWQiOiI1NzgyMjY5OTUyMCJ9"
            target="_blank"
            rel="noreferrer"
          >
            <img src={process.env.PUBLIC_URL + '/images/SocialLearning/Yammer1.png'} alt="oracle-icon" />
            <span>Connect with Community</span>
          </a>
        </button>
        <button className="iconBtn icon3">
          <a href={`mailto:${atci_lkm_sap_mail}`} target="_blank" rel="noreferrer">
            <img src={process.env.PUBLIC_URL + '/images/SocialLearning/mail.svg'} alt="oracle-icon" />
            <span>Contact Us</span>
          </a>
        </button>
      </div>
      <QuickLinks />
    </>
  );
};
export default SapCourses;
